import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IFisco } from "../../interfaces/IFisco";
import FiscoService from "../../services/FiscoService";
import Swal from 'sweetalert2';
import FiscoModal from "./FiscoModal";
import FiscoTabela from "./FiscoTabela";
import FiscoEventoService from "../../services/FiscoEventoService";

function Fisco() {

    const intl = useIntl();
    const { classes } = useLayout();
    const [fiscos, setFiscos] = useState<IFisco[]>([]);
    const [fiscoSelecionado, setFiscoSelecionado] = useState<IFisco>({} as IFisco);
    const [modalTitle, setModalTitle] = useState<string>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [carregado, setCarregado] = useState<boolean>(false);
    const columns = [
        {
            name: 'Fisco',
            selector: (row: IFisco) => row['nome'],
            sortable: true
        },
        {
            name: 'Munícipio - UF',
            selector: (row: IFisco) => row['municipio'],
            sortable: true
        },
        {
            name: 'Ações',
            cell: (row: IFisco) => <AcoesFisco excluirFisco={excluirFisco} editarFisco={async (fisco: IFisco) => {
                setModalTitle('Editar Fisco');

                let fiscoEventos = await FiscoEventoService.obterPorId(fisco.id);
                fisco.fiscoEventos = fiscoEventos;
                setFiscoSelecionado(fisco);
                toggleModal();
            }} item={row} />
        }
    ];

    async function inicializar() {
        setCarregado(false);
        await FiscoService.obterTodos(x => setFiscos(x));
        setCarregado(true);
    }
    
    useEffect(() => {
        async function preCarregar() {
            await inicializar();
        }

        preCarregar();
    }, []);

    function AcoesFisco({ item, excluirFisco, editarFisco }: { item: IFisco, excluirFisco: (fisco: IFisco) => void, editarFisco: (Fisco: IFisco) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => editarFisco(item)} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}></i>
            <i onClick={() => excluirFisco(item)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}></i>
        </div>
    }

    function toggleModal(): void {
        setShowModal(!showModal);

        if (showModal) {
            setTimeout(() => {
                setFiscoSelecionado({} as IFisco)
            }, 300)
        }
    }

    async function excluirFisco(fisco: IFisco) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modal-excluir ms-5',
                cancelButton: 'btn btn-modal-cancelar'
            },
            buttonsStyling: false
        });
        const result = await swalWithBootstrapButtons.fire({
            title: 'Excluir Fisco',
            text: `Você realmente deseja excluir esse fisco?`,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: `Excluir`,
            reverseButtons: true
        });

        if (result.isConfirmed) {
            await FiscoService.excluir(fisco.id, inicializar, 'Fisco excluído com sucesso');
        }
    }

    async function funcaoSucesso() {
        toggleModal();
        await inicializar();
    }

    async function salvar(fisco: IFisco) {
        if (fisco.id !== 0 && fisco.id !== undefined && fisco.id !== null) {
            await FiscoService.alterar(fisco, funcaoSucesso, 'Fisco foi editado com sucesso');
        } else {
            await FiscoService.adicionar(fisco, funcaoSucesso, 'Fisco foi adicionado com sucesso');
        }
    }

    return <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.FISCO' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
                <FiscoModal salvar={salvar} fisco={fiscoSelecionado} title={modalTitle} show={showModal} toggleModal={() => toggleModal()} />
                <div className='d-flex align-items-center py-1'>
                    <button onClick={() => {
                        setModalTitle('Adicionar Fisco');
                        setFiscoSelecionado({}as IFisco);
                        setShowModal(true);
                    }} className='btn btn-sm btn-primario'>
                        <i className="icon-lg text-white fas fa-plus"></i>
                        <span style={{ verticalAlign: 'middle' }}> FISCO </span>
                    </button>
                </div>
            </div>
        </div>
        
        {
            carregado ?
                <FiscoTabela colunas={columns} itens={fiscos} />
            :
                <p>Carregando...</p>
        }
    </>
};

export default Fisco;